import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { transition } from '../assets/jss/material-dashboard-react'



interface Props {
    children: React.ReactNode
    direction?: string
    duration?: number
    delay?: number
    transitionAmount?: number
    isVisible: boolean
}
const SlideInAnimation: React.FC<Props> = ({ children, direction = 'left', duration = 0.8, delay = 0, transitionAmount =100, isVisible }) => {
    const elementReference = useRef<HTMLDivElement>(null)


    const getInitialTransform = ():string => {
        const isHorizontal = direction === 'left' || direction === 'right'
        const xPosition = isHorizontal ? (direction === 'left' ? -transitionAmount : transitionAmount) : 0
        const yPosition = !isHorizontal ? (direction === 'top' ? -transitionAmount : transitionAmount) : 0
        return `translate(${xPosition}px, ${yPosition}px)`
    }


    useEffect(() => {
        const animationElement = elementReference.current
        if (!animationElement) return

        const timeline = gsap.timeline({
            paused: true
        })
        
        const isHorizontal = direction === 'left' || direction === 'right' ? true : false


        const xPosition = isHorizontal
            ? (direction === 'left' ? -transitionAmount : transitionAmount)
            : 0
        const yPosition = !isHorizontal
            ? (direction === 'top' ? -transitionAmount : transitionAmount)
            : 0
       
        if (isVisible) {
            timeline.set(animationElement, {
                x: xPosition,
                y: yPosition,
                opacity: 0
            })


            timeline.to(animationElement, {
                x: 0,
                y: 0,
                opacity: 1,
                duration: duration,
                ease: 'power3.out'
            })
        } else {
            timeline.to(animationElement, {
                x: xPosition,
                y: yPosition,
                opacity: 0,
                duration: duration,
                ease: 'power3.in'
            })
        }


        if (delay > 0) {
            timeline.delay(delay)
        }
        timeline.play()

        return ():void => {
            timeline.kill()
        }
        
    }, [direction, duration, delay])

    return (
        <div
            ref={elementReference}
            style={{
                transform: isVisible ? getInitialTransform() : undefined,
                opacity: isVisible ? 0 : 1
            }}
        >
            {children}
        </div>
    )
}
export default SlideInAnimation